// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".drawer-view {\n  display: flex;\n  flex-direction: row;\n  height: 100%;\n}\n\n.drawer-view > div:first-child {\n  border-right: solid rgb(51, 102, 153) 5px;\n}\n\n.drawer-view > div {\n  height: 100% !important;\n}\n", ""]);
// Exports
module.exports = exports;
